import { Typography } from '@mui/material';

type PageHeaderProps = React.HTMLAttributes<HTMLDivElement> & {
  pageTitle: React.ReactNode;
};

export function PageHeader({ pageTitle, children, ...props }: PageHeaderProps) {
  return (
    <header
      {...props}
      className={`flex items-center justify-between min-h-16 px-8 py-4 border-b ${props.className ?? ''}`}
    >
      <Typography variant="h1">{pageTitle}</Typography>
      <div className="flex justify-end space-x-2 empty:hidden">{children}</div>
    </header>
  );
}
